module.exports = __webpack_public_path__ + "b33906a84b6e4ce2f7b0aece9b9ec435.png";